import React, { useEffect } from "react";
import jexcel, { JExcelElement } from "jexcel";

import { IClassForRegister, IClass } from "../../../state";
import "../../../../node_modules/jexcel/dist/jexcel.css";

import styles from "./ClassSpreadSheet.module.scss";

export interface ClassSpreadSheetProps {
  title: string;
  calling: boolean;
  year: number;
  error: string;
  classes: IClass[];
  save: (classes: IClassForRegister[]) => void;
}
const Fields = {} as { [key: string]: number };
Fields["ID"] = 0;
Fields["学年"] = 1;
Fields["名前"] = 2;
Fields["チェック結果"] = 3;

export const ClassSpreadSheet = (props: ClassSpreadSheetProps) => {
  const jexcelRef = React.useRef<HTMLDivElement>(null);
  const [state, setState] = React.useState({
    sheet: null as null | JExcelElement,
  });
  const save = props.save;
  useEffect(() => {
    const jexcelRefCurrent = jexcelRef.current;
    let sheet = null as null | JExcelElement;
    const options = {
      data: props.classes.length
        ? props.classes.map(c => {
            return [c.id, c.grade, c.name, ""];
          })
        : [[]],
      minSpareRows: 2,
      columns: [
        { type: "text" as const, title: "ID", width: 120, readOnly: true },
        {
          type: "numeric" as const,
          title: "学年",
          width: 100,
        },
        { type: "text" as const, title: "名前", width: 120 },
        { type: "text" as const, title: "チェック結果", width: 250 },
      ],
      onchange: (
        instance: HTMLElement,
        cell: HTMLTableCellElement,
        x: number,
        y: number,
        value: any,
      ) => {
        const dataSet = sheet?.getData();
        const recs = {} as { [key: string]: boolean };
        const rec = sheet?.getRowData(Number(y));
        if (
          rec &&
          (`${x}` === `${Fields["学年"]}` || `${x}` === `${Fields["名前"]}`)
        ) {
          dataSet?.forEach((d, y) => {
            if (`${d[Fields["学年"]]}${d[Fields["名前"]]}`) {
              if (recs[`${d[Fields["学年"]]}-${d[Fields["名前"]]}`]) {
                const result = `${d[Fields["学年"]]}-${
                  d[Fields["名前"]]
                }が被っています。\n`;
                sheet?.setValueFromCoords(
                  Fields["チェック結果"],
                  y,
                  result,
                  false,
                );
              } else {
                sheet?.setValueFromCoords(Fields["チェック結果"], y, "", false);
              }
              recs[`${d[Fields["学年"]]}-${d[Fields["名前"]]}`] = true;
            }
          });
        }
      },
    };
    sheet = jexcel(jexcelRefCurrent as any, options as any);
    setState(s => ({
      ...s,
      sheet,
    }));
    return () => {
      jexcelRefCurrent?.remove();
    };
  }, [props.classes]);

  const addRow = React.useCallback(() => {
    state.sheet?.insertRow();
  }, [state.sheet]);

  const saveFunc = React.useCallback(() => {
    const data = [] as IClassForRegister[];
    if (state.sheet) {
      const dataSet = state.sheet?.getData();
      dataSet.forEach(d => {
        if (d[Fields["学年"]] !== 0 && d[Fields["名前"]] !== "") {
          data.push({
            id: d[Fields["ID"]] as number,
            grade: d[Fields["学年"]] as number,
            name: d[Fields["名前"]] as string,
          });
        }
      });
    }
    save(data);
  }, [save, state.sheet]);

  return (
    <div className={styles.wrapper}>
      <h3>{props.title}</h3>
      <div
        style={{ width: "100%", height: "100%", color: "#000" }}
        ref={jexcelRef}
      />
      <p className={styles.note}>
        ※「チェック結果」にエラーが表示されている行は登録されませんので、エラーを修正してから登録してください。
      </p>
      <div className={styles.action}>
        <button className="btn btn-primary" onClick={addRow}>
          追加
        </button>
        <button
          className="btn btn-primary"
          onClick={saveFunc}
          disabled={props.calling}
        >
          登録
        </button>
      </div>
    </div>
  );
};

export default ClassSpreadSheet;
